import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Instance } from '../../../models/instance';

@Injectable({
  providedIn: 'root'
})
export class InstanceService {

  private endpointPrefix = environment.apiUrl;

  constructor(private http: HttpClient) { }

  public createInstance(payload: any) {
    return this.http.post(`${this.endpointPrefix}/instances`, payload);
  }

  public getAllInstances(customerId: number) {
    return this.http.get<Instance[]>(`${this.endpointPrefix}/instances`);
  }

  public getInstanceById(id: number) {
    return this.http.get<Instance>(`${this.endpointPrefix}/instances/${id}`);
  }

  public updateInstance(id: number, payload: any) {
    return this.http.patch(`${this.endpointPrefix}/instances/${id}`, payload);
  }

  public deleteInstances(instances: Instance[]) {
    return this.http.delete(`${this.endpointPrefix}/instances/delete-any`, { body: instances });
  }
  public deleteInstance(id: number) {
    return this.http.delete(`${this.endpointPrefix}/instances/${id}`);
  }


  getInstanceByCategory(categoryId: number) {
    return this.http.get<Instance[]>(`${this.endpointPrefix}/categories/${categoryId}/instances`);
  }

  public exportInstances(instances: Instance[]) {
    return this.http.post(`${this.endpointPrefix}/instances/export`, instances, { responseType: 'blob' });
  }

  public importInstances(categoryId: number, payload: FormData) {
    return this.http.post(`${this.endpointPrefix}/categories/${categoryId}/import`, payload, { reportProgress: true, observe: 'events', });
  }
}
